/**
 */
define('constant/memberservices/commodity.constant',[], function () {
    return {
        argeementNo : 1049,

        orderStatus: {
            "1": "支付失败",
            "2": "支付成功",
            "3": "支付成功",
            "4": "支付成功",
            "5": "退款中",
            "6": "退款成功",
            "7": "退款失败"
        },

        orderType: {
            "1": "首次订购",
            "2":"续订",
            "3":"自动续订"
        },

        commodityCycle : {
            "1":"一年",
            "2":"半年",
            "3":"一季度",
            "4":"一个月"
        },

        commodityCycle1 : {
            "1":"年",
            "2":"半年",
            "3":"季度",
            "4":"月"
        },

        showUnit: {
            1: 'Bytes',
            2: 'MB',
            3: 'GB',
            4: 'TB',
            5: '个',
            6: '次'
        },

        currencyType: {
            'CNY': '￥',
            'USD': '$',
            'EUR': '€'
        },

        effectiveType: {
            1 : "立即生效",
            2 : "次月生效"
        },

        renewType: {
            1 : '支持',
            2 : '不支持'
        },

        repeatOrder :{
            1 : '支持',
            2 : '不支持'
        },

        limitPeriodType : {
            1 : '天',
            2 : '周',
            3 : '月',
            4 : '年'
        }
    }
});

